"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getColumnMap = (columns) => {
    const obj = {};
    columns.forEach((column) => {
        obj[column.id] = column;
    });
    return obj;
};
const getErrors = (stateMap, columns) => {
    const columnMap = getColumnMap(columns);
    const errors = {};
    Object.keys(stateMap).forEach((columnId) => {
        const column = columnMap[columnId];
        const value = stateMap[columnId];
        if (value === column.defaultValue) {
            errors[columnId] = column.emptyError;
        }
    });
    return errors;
};
exports.default = getErrors;
//# sourceMappingURL=getErrors.js.map